<script lang="ts">
  import NavItem from './NavItem.svelte';
  import ChildPage from './ChildPage.svelte';
  import AdditionalNavItem from './AdditionalNavItem.svelte';

  interface Props {
    list?: VerticalNavType[];
    active?: string;
    hasCount?: boolean;
    countMap?: any;
    children?: VerticalNavType[];
    childActive?: string;
    childrenTitle?: string;
    additionalNavs?: VerticalNavType[];
    childAdditionalNavs?: VerticalNavType[];
    onclick?: (nav: VerticalNavType) => void;
    onclickchild?: (nav: VerticalNavType) => void;
    onclickchildback?: () => void;
    onclickadditionalnav?: (nav: VerticalNavType) => void;
    onclickchildadditionalnav?: (nav: VerticalNavType) => void;
  }

  let {
    list = [],
    active = '',
    hasCount = false,
    countMap = {},
    children = [],
    childActive = '',
    childrenTitle = '',
    additionalNavs = [],
    childAdditionalNavs = [],
    onclick,
    onclickchild,
    onclickchildback,
    onclickadditionalnav,
    onclickchildadditionalnav
  }: Props = $props();

  let activeArr = $derived(active?.split('/') || []);
  let activeParent = $derived(activeArr[0]);
  let activeChild = $derived(activeArr.slice(0, 2).join('/'));

  const hasChildren = (nav: VerticalNavType): boolean => {
    return nav && nav.children && nav.children.length !== 0;
  };

  const handleClickNav = (nav: VerticalNavType): void => {
    onclick?.(nav);
  };

  const onClickChildNav = (nav: VerticalNavType): void => {
    onclickchild?.(nav);
  };

  const onClickChildBack = (): void => {
    onclickchildback?.();
  };

  const onClickAdditionalNav = (nav: VerticalNavType): void => {
    onclickadditionalnav?.(nav);
  };
</script>

<div class="comp-veritical-nav">
  {#if children.length !== 0}
    <ChildPage
      name={childrenTitle}
      active={childActive}
      list={children}
      additionalNavs={childAdditionalNavs}
      onclick={onClickChildNav}
      onback={onClickChildBack}
      onclickchildadditionalnav={onclickchildadditionalnav}
    />
  {:else}
    {#each list as nav}
      {#if !nav?.hidden}
        <NavItem
          {hasCount}
          {countMap}
          {nav}
          active={activeParent === nav.id}
          onclick={() => {
            handleClickNav(nav);
          }}
        >
          <div  class="nav-children">
            {#if hasChildren(nav)}
              {#each nav.children as childNav}
                {#if !childNav?.hidden}
                  <NavItem
                    {hasCount}
                    {countMap}
                    nav={childNav}
                    active={activeChild === childNav.id}
                    onclick={() => {
                      handleClickNav(childNav);
                    }}
                  />
                {/if}
              {/each}
            {/if}
          </div>
        </NavItem>
      {/if}
    {/each}

    <div class="additional-navs">
      {#each additionalNavs as nav}
        {#if !nav?.hidden}
          <AdditionalNavItem {nav} {active} onclick={() => onClickAdditionalNav(nav)} />
        {/if}
      {/each}
    </div>
  {/if}
</div>

<style>
  .comp-veritical-nav {
    display: flex;
    flex-direction: column;
  }

  .nav-children {
    padding-left: 12px;
    border-left: 1px solid rgba(0, 0, 0, 0.06);
    margin: 10px 0 10px 12px;
  }
  .additional-navs {
    margin-top: 28px;
  }
</style>
